module.exports = __webpack_public_path__ + "img/_weapon_ring_12.99a78308.png";